import React from 'react';
import TrueLinkIcon from 'react/shared/components/true_link/main/TrueLinkIcon';
import PALETTE from 'react/shared/theme/palette';

export default function LockAdornment() {
  return <TrueLinkIcon icon="lock" style={{ color: PALETTE.emerald, marginRight: '1rem' }} />;
}
